import React from 'react';

const StatCard = ({ icon, label, value, color = '#2563eb', bgColor = '#dbeafe' }) => {
  return (
    <div className="stat-card">
      <div className="stat-icon" style={{ background: bgColor, color }}>
        {icon}
      </div>
      <div className="stat-value">{value}</div>
      <div className="stat-label">{label}</div>
    </div>
  );
};

export default StatCard;
